import { FIELD_TYPES } from './types';

export const normalizeFieldName = (value = '') => {
  const normalized = value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

  return normalized || 'field';
};

export const getUniqueFieldName = (sections = [], desiredName = '', editingFieldId = null) => {
  const baseName = normalizeFieldName(desiredName);
  const existingNames = new Set(
    sections
      .flatMap((section) => section.fields || [])
      .filter((field) => field.id !== editingFieldId)
      .map((field) => normalizeFieldName(field.name || ''))
  );

  if (!existingNames.has(baseName)) {
    return baseName;
  }

  let suffix = 2;
  let candidateName = `${baseName}_${suffix}`;

  while (existingNames.has(candidateName)) {
    suffix += 1;
    candidateName = `${baseName}_${suffix}`;
  }

  return candidateName;
};

export const isDisplayOnlyField = (field) => field?.type === FIELD_TYPES.LABEL;

export const isAnswerableField = (field) => !isDisplayOnlyField(field);

export const isFieldValueFilled = (field, value) => {
  if (!isAnswerableField(field)) {
    return true;
  }

  if (field?.type === FIELD_TYPES.CHECKBOX) {
    return value === true;
  }

  if (field?.type === FIELD_TYPES.CHECKBOX_GROUP || field?.type === FIELD_TYPES.TABLE) {
    return Array.isArray(value) && value.length > 0;
  }

  return value !== undefined && value !== null && String(value).trim() !== '';
};

export const getMissingRequiredFields = (template, formData = {}) => {
  if (!template?.sections) {
    return [];
  }

  return template.sections.flatMap((section) =>
    (section.fields || []).filter(
      (field) => isAnswerableField(field) && field.required && !isFieldValueFilled(field, formData[field.name])
    )
  );
};